/* ============================================================
   ASCENSION APPAREL — Shopify Theme JS
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ---- Hero Slider ----
  initHeroSlider();

  // ---- Product Gallery Thumbnails ----
  initProductGallery();

  // ---- Product Variant Selector ----
  initVariantSelector();

  // ---- Quantity Controls ----
  initQuantityControls();

  // ---- Cart Quantity Controls ----
  initCartQuantityControls();

});

/* ---- Hero Slider ---- */
function initHeroSlider() {
  var slides = document.querySelectorAll('.hero-slide');
  var dots = document.querySelectorAll('.dot');
  if (!slides.length) return;

  var current = 0;
  var total = slides.length;
  var interval;

  function goTo(index) {
    slides[current].classList.remove('active');
    if (dots[current]) dots[current].classList.remove('active');
    current = (index + total) % total;
    slides[current].classList.add('active');
    if (dots[current]) dots[current].classList.add('active');
  }

  function startAutoplay() {
    interval = setInterval(function () {
      goTo(current + 1);
    }, 4000);
  }

  function stopAutoplay() {
    clearInterval(interval);
  }

  // Dot click
  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      stopAutoplay();
      goTo(i);
      startAutoplay();
    });
  });

  // Touch/swipe support
  var touchStartX = 0;
  var sliderEl = document.querySelector('.hero-slider');
  if (sliderEl) {
    sliderEl.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    sliderEl.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 50) {
        stopAutoplay();
        goTo(diff > 0 ? current + 1 : current - 1);
        startAutoplay();
      }
    }, { passive: true });
  }

  startAutoplay();
}

/* ---- Product Gallery Thumbnails ---- */
function initProductGallery() {
  var thumbBtns = document.querySelectorAll('.thumb-btn');
  var mainImg = document.getElementById('main-product-image');
  if (!thumbBtns.length || !mainImg) return;

  thumbBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      thumbBtns.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var newSrc = btn.getAttribute('data-src');
      if (newSrc) {
        mainImg.style.opacity = '0';
        setTimeout(function () {
          mainImg.src = newSrc;
          mainImg.style.opacity = '1';
        }, 200);
      }
    });
  });
}

/* ---- Product Variant Selector ---- */
function initVariantSelector() {
  var optionBtns = document.querySelectorAll('.size-btn, .option-btn, .color-swatch');
  var variantInput = document.querySelector('input[name="id"]');
  if (!optionBtns.length) return;

  optionBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var index = btn.getAttribute('data-option-index');
      var siblings = document.querySelectorAll('[data-option-index="' + index + '"]');
      siblings.forEach(function (s) { s.classList.remove('selected'); });
      btn.classList.add('selected');
      updateVariant();
    });
  });

  function updateVariant() {
    // Shopify variant matching — reads selected option values
    var selectedOptions = [];
    var optionGroups = {};
    optionBtns.forEach(function (btn) {
      if (btn.classList.contains('selected')) {
        var idx = btn.getAttribute('data-option-index');
        optionGroups[idx] = btn.getAttribute('data-value');
      }
    });
    var keys = Object.keys(optionGroups).sort();
    keys.forEach(function (k) { selectedOptions.push(optionGroups[k]); });

    // Try to find matching variant from global window.productVariants
    if (window.productVariants && variantInput) {
      var match = window.productVariants.find(function (v) {
        return selectedOptions.every(function (opt, i) {
          return v.options[i] === opt;
        });
      });
      if (match) {
        variantInput.value = match.id;
        // Update price display
        var priceEl = document.querySelector('.price-current');
        if (priceEl && match.price) {
          priceEl.textContent = formatMoney(match.price);
        }
      }
    }
  }
}

/* ---- Quantity Controls ---- */
function initQuantityControls() {
  var minusBtns = document.querySelectorAll('.product-page .qty-minus');
  var plusBtns = document.querySelectorAll('.product-page .qty-plus');

  minusBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('.qty-input');
      if (input) {
        var val = parseInt(input.value, 10) || 1;
        if (val > 1) input.value = val - 1;
      }
    });
  });

  plusBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('.qty-input');
      if (input) {
        var val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
      }
    });
  });
}

/* ---- Cart Quantity Controls ---- */
function initCartQuantityControls() {
  var cartMinusBtns = document.querySelectorAll('.cart-page .qty-minus');
  var cartPlusBtns = document.querySelectorAll('.cart-page .qty-plus');

  cartMinusBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-id');
      var input = document.getElementById('updates_' + id);
      if (input) {
        var val = parseInt(input.value, 10) || 1;
        input.value = Math.max(0, val - 1);
      }
    });
  });

  cartPlusBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-id');
      var input = document.getElementById('updates_' + id);
      if (input) {
        var val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
      }
    });
  });
}

/* ---- Utility: Format Money ---- */
function formatMoney(cents) {
  var amount = (cents / 100).toFixed(2);
  return '\u00A3' + amount;
}
